import styled from 'styled-components';

const Card = styled.button<{ $isSelected: boolean }>`
  display: flex;
  align-items: stretch;
  min-width: 0;
  width: 100%;
  max-width: 320px;
  min-height: 80px;
  border-radius: 8px;
  background:  ${(props) => (props.$isSelected ? props.theme.colors.main_cta : props.theme.colors.widget_background)};
  box-sizing: border-box;
  overflow: hidden;

  @media (min-width: 400px) {
    max-height: 104px;
    width: auto;
    width: 213px;
  }
`;

const Main = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 10px 12px 14px;

  @media (min-width: 400px) {
    padding: 12px 12px 12px 12px;
    gap: 6px;
  }
`;

const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
`;

const PlayButton = styled.button`
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  min-width: 34px;
  min-height: 34px;
  border-radius: 4px;
  border: none;
  background: ${(props) => props.theme.colors.outline};
  color: ${(props) => props.theme.colors.white};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &:hover {
    background: ${(props) => props.theme.colors.widget_hover_background};
  }
  &:focus {
    outline: none;
  }
`;

const Content = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-left: 0;
`;

const FileName = styled.span<{ $isSelected: boolean }>`
  font-size: 13px;
  line-height: 1.35;
  color: ${(props) => (props.$isSelected ? props.theme.colors.black : props.theme.colors.text)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Meta = styled.span<{ $isSelected: boolean }>`
  font-size: 12px;
  line-height: 1.35;
  color: ${(props) => (props.$isSelected ? props.theme.colors.black : props.theme.colors.inactive)};
`;

const Actions = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: auto;
`;

const IconButton = styled.button<{ danger?: boolean }>`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  color: ${(props) => (props.danger ? props.theme.colors.red : props.theme.colors.inactive)};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    color: ${(props) => (props.danger ? props.theme.colors.red : props.theme.colors.white)};
  }
  &:focus {
    outline: none;
  }
`;

const SendBar = styled.div`
  width: 44px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.colors.outline};
  border-left: 1px solid ${(props) => props.theme.colors.outline};
`;

const CardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top:20px;
  margin-bottom:40px;
`;

const SendButton = styled.button`
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;
  background: transparent;
  color: ${(props) => props.theme.colors.white};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${(props) => props.theme.colors.main_cta};
  }
  &:focus {
    outline: none;
  }
`;

const TimeoutSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 0;
`;

const TimeoutLabel = styled.label`
  font-size: 16px;
  font-weight: 600;
  padding-bottom: 8px;
  color: ${(props) => props.theme.colors.text};
  margin: 0;
`;

const DatePickerWrap = styled.div`
  width: 100%;
  max-width: 190px;

  &.assign-announcement-timeout .react-datepicker-wrapper {
    display: block;
    width: 100%;
  }
  &.assign-announcement-timeout .react-datepicker__input-container {
    display: block;
    width: 100%;
  }
  &.assign-announcement-timeout .react-datepicker-time__header {
    color: ${(props) => props.theme.colors.text};
  }
  &.assign-announcement-timeout .react-datepicker__input-container input {
    width: 100%;
    height: 44px;
    padding: 12px 40px 12px 16px;
    box-sizing: border-box;
    border-radius: 12px;
    border: 1px solid ${(props) => props.theme.colors.outline};
    background-color: ${(props) => props.theme.colors.widget_background};
    color: ${(props) => props.theme.colors.text};
    font-size: 13px;
    caret-color: ${(props) => props.theme.colors.main_cta};
  }

  &.assign-announcement-timeout .react-datepicker__input-container input::placeholder {
    color: ${(props) => props.theme.colors.inactive};
  }

  &.assign-announcement-timeout .react-datepicker__input-container input:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.main_cta};
  }
`;

const DatePickerInputWrap = styled.div`
  position: relative;
  width: 100%;
`;

const DatePickerIconWrap = styled.button`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  color: ${(props) => props.theme.colors.inactive};
`;

const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  margin-top: 8px;
  padding: 8px 12px;

  border-radius: 8px;

  background: rgba(255, 193, 7, 0.15);
  border: 1px solid rgba(255, 193, 7, 0.45);

  color: #b58100;
  font-size: 13px;
  font-weight: 500;

  svg {
    width: 16px;
    height: 16px;
  }
`;

const ErrorWrapper = styled.div`
  min-height: 40px;
`;
const EmptyMessage = styled.p`
  margin-top: 10px;
  margin-bottom:120px;
  font-size: 14px;
  color: ${(props) => props.theme.colors.inactive};
`;

const styles = {
  Card,
  Main,
  TopRow,
  PlayButton,
  Content,
  FileName,
  Meta,
  Actions,
  IconButton,
  SendBar,
  SendButton,
  CardsWrapper,
  TimeoutSection,
  TimeoutLabel,
  DatePickerWrap,
  DatePickerInputWrap,
  DatePickerIconWrap,
  ErrorMessage,
  ErrorWrapper,
  EmptyMessage,
};

export default styles;
